import { absolutePath } from "./absolutePath";

export interface AiWorkflowsBillingHistoryParams {
  end_date: string;
  free_quantity: number;
  page?: number;
  per_page?: number;
  price_overage: number;
  sort_direction?: "asc" | "desc";
  sort_field?: string;
  start_date: string;
}

interface AiWorkflowsBillingHistoryFnProps {
  params: AiWorkflowsBillingHistoryParams;
}

export const aiWorkflowsBillingHistory = {
  list: ({ params }: AiWorkflowsBillingHistoryFnProps) =>
    absolutePath("ai_workflows_billing", params),
};
